
























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import {
  FormFieldDefMap,
  emitFormChangeEvent,
} from '@/reusable/Form/formUtils';
import config from '@/config/index';
import HandleErrors from '@/config/handleErrors';
import { LoadingService } from '@/services/loadingService';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { fetchFolio } from '@/pantallas/ConsultarFolio/fetchFolio';
import { date, number } from 'node_modules/@types/yup';
import { Snotify } from '@/snotify/Snotify';

@Component({
  components: {
    FormFieldsContainer,
  },
})
export default class ConsultarFolio extends Vue {
  //definición de campos
  formFields: FormFieldDefMap = {
    nroFolio: {
      label: 'Número de Folio',
      id: 'nroFolio',
      value: '',
    },
  };

  //control validaciones
  dictionaryFormErrors: any = {};
  handleErrors: HandleErrors = new HandleErrors();
  loadingService = new LoadingService();
  txtFolio: string;
  urlPdf: string;
  readonly $snotify: Snotify;

  constructor() {
    super();

    this.dictionaryFormErrors = {
      custom: {
        nroFolio: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
          numeric: config.errorMensajes.soloNumeros,
        },
      },
    };

    this.$validator.localize('es', this.dictionaryFormErrors);
    this.txtFolio = '';
    this.urlPdf = '';
  }

  //buscar
  async handleBuscarClick() {
    const resultadoValidacion = await this.$validator.validateAll();
    if (resultadoValidacion) {
      await this.buscar(Number(this.formFields.nroFolio.value));
    }
  }

  //limpiar
  clearFilters() {
    this.formFields.nroFolio.value = '';
    this.$emit('clear');
  }

  //buscar
  async buscar(id: number) {
    const he = new HandleErrors();
    try {
      this.loadingService.showLoading();
      const response = await fetchFolio(id).then(async (res: any) => {
        await this.generarPDF(res, id);
      });
    } catch (error) {
      if (error.response !== undefined) {
        if (error.response.status !== 401) {
          this.errorMSG(
            error,
            he,
            'Ha ocurrido un problema al intentar buscar el Folio.'
          );
        }
      } else {
        this.errorMSG(
          error,
          he,
          'Ha ocurrido un problema al intentar buscar el Folio.'
        );
      }
    } finally {
      this.loadingService.hideLoading();
    }
  }

  //genera pdf
  generarPDF(res: any, id: number) {
    var file = new Blob([res.data], { type: 'application/pdf' });
    if (file.size > 0) {
      var fileURL = URL.createObjectURL(file);
      this.txtFolio = '- N° Folio: ' + String(id);
      this.urlPdf = fileURL + '#zoom=100';
      document.getElementById('div_Cert').style.display = 'block';
    } else {
      document.getElementById('div_Cert').style.display = 'none';
      this.$snotify.warning('Folio no encontrado', {
        timeout: 3000,
      });
    }
  }

  //control errores
  errorMSG(error: any, he: HandleErrors, msg: string) {
    he.showError(error, msg);
  }
}
